"use strict";
angular.module('initPaperDataModule', []).
factory('initPaperDataService', [function() {
    return {
        initText: function() {
            var list = {
                "METADATAID": 0,
                "TITLECOLOR":"",
                "TITLE": "",
                "SUBTITLE": "",
                "JTITLE": "",
                "CONTENT": "",
                "DOCSOURCE": "",
                "AUTHOR": "",
                "KEYWORDS": "",
                "ABSTRACT": "",
                "DOCGENRE": "",
                "HTMLCONTENT": "",
                "DOCWORDSCOUNT": 0,
                "ISNOPAYMENT": "1",
                "REMARKS": "",
                "FGD_EDITINFO": [],
                "FGD_AUTHINFO": [{ "isCreate": true }],
                "ORIGINAL": "0",
                "VIDEOREL": [],
                "MEDIATYPES": "0",
                "ISCONTAINSENSITIVEWORDS": 0,
                "SENSITIVEWORDS": ""
            };
            return list;
        },
        initPic: function() {
            var list = {
                "METADATAID": 0,
                "TITLECOLOR":"",
                "TITLE": "",
                "SUBTITLE": "",
                "JTITLE": "",
                "DOCSOURCE": "",//稿件来源
                "AUTHOR": "",
                "CONTRIBUTORS": "",
                "KEYWORDS": "",
                "CONABSTRACT": "",
                "DOCGENRE": "",
                "ISNOPAYMENT": "1",
                "DOC_PICTURELIST": [],
                "SOURCEMETAID": "",
                "FLOWVERSIONTIME": "",
                "REMARKS": "",
                "DOCWORDSCOUNT": 0,
                "FGD_EDITINFO": [],
                "FGD_AUTHINFO": [{ "isCreate": true }],
                "ORIGINAL": "0",
                "HTMLCONTENT": "",
                "CONTENT": "",
                "VIDEOREL": [],
                "MEDIATYPES": "0",
                "ISCONTAINSENSITIVEWORDS": 0,
                "SENSITIVEWORDS": ""
            };
            return list;
        }
    };
}]);
